import React from 'react';

import EditableProfileIcon from '../EditableProfileIcon';
import ProfileIcon from '../ProfileIcon';

import {
  Description,
  Name,
  NameContainer,
  PaperContainer,
} from './index.styles';

type ProfileIconProps = React.ComponentProps<typeof ProfileIcon>;

interface ProfileHeaderProps {
  profileIconProps: ProfileIconProps
  name: string,
  description?: string,
  onIconEdit?: () => void,
}

const ProfileHeader = ({ profileIconProps,
  name,
  description,
  onIconEdit }: ProfileHeaderProps) =>
  (
    <PaperContainer>
      {onIconEdit ? (
        <EditableProfileIcon
          {...profileIconProps}
          size={96}
          onUpdate={onIconEdit}
        />
      ) : (
        <ProfileIcon
          {...profileIconProps}
          size={96}
        />
      )}
      <NameContainer>
        <Name variant="h5" color="darkPrimary">{name}</Name>
        <Description variant="caption" color="darkPrimary">{description}</Description>
      </NameContainer>
    </PaperContainer>
  );

export default ProfileHeader;
